import { useState } from "react";

interface PreviousTreatmentRow {
  selected: boolean;
  drug: string;
  stage: string;
  outcome: string;
}

interface PreviousTreatmentsTableProps {
  value?: PreviousTreatmentRow[];
  onChange: (value: PreviousTreatmentRow[]) => void;
}

const PreviousTreatmentsTable = ({
  value = [],
  onChange,
}: PreviousTreatmentsTableProps) => {
  // Initialize with 3 empty rows if no value provided
  const [treatments, setTreatments] = useState<PreviousTreatmentRow[]>(
    value.length > 0
      ? value
      : [
          { selected: false, drug: "", stage: "", outcome: "" },
          { selected: false, drug: "", stage: "", outcome: "" },
          { selected: false, drug: "", stage: "", outcome: "" },
        ],
  );

  const updateTreatment = (
    index: number,
    field: keyof PreviousTreatmentRow,
    newValue: string | boolean,
  ) => {
    const updatedTreatments = [...treatments];
    updatedTreatments[index] = {
      ...updatedTreatments[index],
      [field]: newValue,
    };
    setTreatments(updatedTreatments);
    onChange(updatedTreatments);
  };

  return (
    <div className="previous-treatments-table">
      <div className="mb-4">
        <h4 className="mb-2 text-sm font-medium text-primaryGray-1">
          H. List the other treatment tried and failed with the associated
          outcome (failure, intolerance, etc.)
        </h4>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full border border-primaryGray-12">
          <thead>
            <tr className="bg-primaryGray-17">
              <th className="border border-primaryGray-12 px-3 py-2 text-left text-sm font-medium text-primaryGray-1"></th>
              <th className="border border-primaryGray-12 px-3 py-2 text-left text-sm font-medium text-primaryGray-1">
                Drug / Regimen
              </th>
              <th className="border border-primaryGray-12 px-3 py-2 text-left text-sm font-medium text-primaryGray-1">
                Stage of disease
              </th>
              <th className="border border-primaryGray-12 px-3 py-2 text-left text-sm font-medium text-primaryGray-1">
                Outcome
              </th>
            </tr>
          </thead>
          <tbody>
            {treatments.map((treatment, index) => (
              <tr key={index} className="bg-white">
                <td className="border border-primaryGray-12 px-3 py-2">
                  <div className="flex items-center">
                    <input
                      type="checkbox"
                      checked={treatment.selected}
                      onChange={(e) =>
                        updateTreatment(index, "selected", e.target.checked)
                      }
                      className="h-4 w-4 rounded border-primaryGray-12 text-tertiaryBlue-4 focus:ring-tertiaryBlue-4"
                    />
                    <label className="ml-2 text-sm text-primaryGray-1">
                      Drug {index + 1}
                    </label>
                  </div>
                </td>
                <td className="border border-primaryGray-12 px-2 py-1">
                  <input
                    type="text"
                    value={treatment.drug}
                    onChange={(e) =>
                      updateTreatment(index, "drug", e.target.value)
                    }
                    className="w-full border-none bg-transparent px-1 py-1 text-sm focus:outline-none focus:ring-1 focus:ring-tertiaryBlue-4"
                    placeholder="Enter drug/regimen name"
                  />
                </td>
                <td className="border border-primaryGray-12 px-2 py-1">
                  <input
                    type="text"
                    value={treatment.stage}
                    onChange={(e) =>
                      updateTreatment(index, "stage", e.target.value)
                    }
                    className="w-full border-none bg-transparent px-1 py-1 text-sm focus:outline-none focus:ring-1 focus:ring-tertiaryBlue-4"
                    placeholder="e.g., Stage 4"
                  />
                </td>
                <td className="border border-primaryGray-12 px-2 py-1">
                  <input
                    type="text"
                    value={treatment.outcome}
                    onChange={(e) =>
                      updateTreatment(index, "outcome", e.target.value)
                    }
                    className="w-full border-none bg-transparent px-1 py-1 text-sm focus:outline-none focus:ring-1 focus:ring-tertiaryBlue-4"
                    placeholder="e.g., Failed, Intolerance"
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PreviousTreatmentsTable;
